import React, { useState } from 'react';
import DateInput from './DateInput';

function getLocalDate() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export default function PhoneCallForm({ initial = {}, onSubmit, onCancel }) {
  const today = getLocalDate();
  const [form, setForm] = useState({
    phoneCallDate: initial.phoneCallDate ? initial.phoneCallDate.slice(0, 10) : today,
    phoneCallNote: initial.phoneCallNote || '',
    followUpDate: initial.followUpDate ? initial.followUpDate.slice(0, 10) : today
  });

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  return (
    <form onSubmit={(e) => { e.preventDefault(); onSubmit(form); }}>
      <div className="form-group">
        <label>תאריך שיחה</label>
        <DateInput name="phoneCallDate" value={form.phoneCallDate} onChange={handleChange} required />
      </div>
      <div className="form-group">
        <label>תיאור</label>
        <textarea name="phoneCallNote" value={form.phoneCallNote} onChange={handleChange} rows={4} />
      </div>
      <div className="form-group">
        <label>תאריך מעקב</label>
        <DateInput name="followUpDate" value={form.followUpDate} onChange={handleChange} required />
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
        <button type="submit" className="btn btn-primary">שמור</button>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>ביטול</button>
      </div>
    </form>
  );
}
